export default __webpack_public_path__ + "locales/az/JavascriptSdk.json?hash=b3a2688423a07dc193710804caa19eed";